import { Button } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { dogUrlGenerator } from "../../../util.js/dogUrlGenerator"
import { url } from "../../weburl"
import { ChangeDogUserModal } from "../mini-components/adminChangeDogUserModal"
import { AdminNav } from "../mini-components/admin_nav"
import { AdminDogsDetailSearch } from "./adminDogDetailsSearch"
import Swal from 'sweetalert2';
import { AdminMainWrapper } from "../mini-components/admin-main-wrapper"
import { AiOutlineArrowLeft } from "react-icons/ai";



export const AdminDogsDetailSpecific = () => {
    const [dog, setDog] = useState({})
    const params = useParams()
    const navigate = useNavigate()
    console.log(params.dog_id)

    const getspecificdog = () => {
        axios
            .get(`${url}api/dogs/${params.dog_id}`)
            .then((res) => {
                setDog(res.data)
            }
            )
            .catch((err) => {
                console.log("Error couldnt get Dog");
                console.log(err.message);
            });
    }

    useEffect(() => {
        getspecificdog()
    }, [])

    const deleteDog = () => {

        axios
            .delete(`${url}api/dogs/${dog.id}`)
            .then((res) => {
                // console.log(res.data)
                Swal.fire('Deleted!', '', 'success')
            }
            )
            .catch((err) => {
                console.log("Error couldnt get Dog");
                console.log(err.message);
            });
    }
    return (
        <AdminMainWrapper >


            {dog && <div className="container pt-5 bg-white">
            
                <div className="row align-items-start justify-content-center text-left">

                    <div className="col-md-4">
                        <div className="pb-5">
                            <AiOutlineArrowLeft onClick={() => navigate(-1)} />
                        </div>
                        {dog.public_id ? <img src={`https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${dog.public_id}.png`}
                            className='w-100' /> :
                            <p>No image</p>
                        }
                        <div className="">
                            <div>
                                <Link to={`/dog_registrations/edit/${dog.id}/admin`}><Button sx={{ color: "#ba8108" }} >
                                    Edit</Button ></Link>
                            </div>
                            <div>
                                <Button sx={{ color: "red" }}
                                    onClick={e =>
                                        Swal.fire({
                                            title: `ARE YOU SURE YOU WANT TO DELETE ${dog.name}?`,
                                            showDenyButton: true,
                                            showCancelButton: true,
                                            confirmButtonText: 'Delete',
                                            denyButtonText: `Don't delete`,
                                        }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                                deleteDog()

                                            } else if (result.isDenied) {
                                                Swal.fire('Changes are not saved', '', 'info')
                                            }
                                        })

                                    }>
                                    Delete</Button >
                            </div>
                            <div>
                                {dog.name && <Link to={`/my_dogs/${dog.id}/${dogUrlGenerator(dog.name)}}`}><Button sx={{ color: "#ba8108" }} >
                                    Go to pedigree</Button ></Link>}
                            </div>
                            <div>

                                <ChangeDogUserModal dog_id={dog.id} dog_name={dog.name} />

                            </div>
                        </div>

                    </div>
                    <div className="col-sm-8">
                        <div className="row ">
                            <h1 className="brand-yellow-font font-weight-bold">{dog.name}</h1>

                        </div>
                        <hr />
                        <div className="row align-items-start justify-content-start">
                            <div className="col-md-5 " >
                                <p>ID: {dog.id}</p>
                                <p>AGE:
                                    {dog.age}

                                </p>  IMAGE URL:                       {dog.image_url}
                                <p> BREED:
                                    {dog.breed}
                                </p>
                                <p>SIRE: {dog.sire}</p>
                                <p>DAM: {dog.dam}</p>
                                <p>SEX: {dog.sex}</p>
                                <p>DATE OF BIRTH: {dog.date_of_birth}</p>
                                <p>PUBLIC ID: {dog.public_id}</p>
                                <p>USER: {dog.user}</p>
                                <p>CURRENT OWNER: {dog.current_owner}</p>
                                <p>PLACE OF BIRTH: {dog.place_of_birth}</p>
                                <p>KERNEL NAME: {dog.kennel_name}</p>


                            </div>

                            <div className="col-sm-6">
                                <p>LAND OF STANDING: {dog.land_of_standing}</p>
                                <p>AFBR NO: {dog.afbr_no}</p>
                                <p>HEIGHT: {dog.height}</p>
                                <p>WEIGHT: {dog.weight}</p>
                                <p>COLOR: {dog.color}</p>
                                <p>PROGENY{dog.num_of_progeny}</p>
                                <p>IMAGE FORMAT{dog.image_format}</p>
                                <p>DATE REGISTERED{dog.date_registered}</p>
                                <p>AS BEEN PAID FOR{dog.hasBeenPaidFor}</p>
                                <p> EXPRESSPAY TOKEN{dog.expresspay_token}</p>
                                <p>EXPRESSPAY ORDER ID{dog.expresspay_order_id}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>}
        </AdminMainWrapper>
    )
}